import { Box, Flex, FloraTypography } from '@grupoboticario/flora-react'

import { BackofficeImage } from '@/components/BackofficeImage/BackofficeImage'

import * as S from './LargeText.styles'

const LargeText = ({ lengthToBreak = 21, onOpenClick = () => {}, text = '' }) => (
  <Flex align="center" gap="$1">
    <FloraTypography as="div" css={S.truncatedTextCss} fontSize="bodySmallStandard">
      {text}
    </FloraTypography>
    {text.length > lengthToBreak && (
      <Box css={S.expandIconCss}>
        <BackofficeImage
          alt={`Ver texto em tela cheia`}
          height={24}
          onClick={() => onOpenClick(text)}
          src="/img/eye.svg"
          width={24}
        />
      </Box>
    )}
  </Flex>
)

export default LargeText
